import * as _ from 'lodash'
import { DocumentT, JobT } from '../../../../types/Job'
import { VariableDocumentT } from './DocumentVariables'

export const getVariablesForDocument = (newJob: JobT, documentName: string, defaultVariables = null): Array<VariableDocumentT> => {
  return _.has(newJob, `documents.${documentName}.variables`) && newJob.documents[documentName].variables
    ? newJob.documents[documentName].variables
    : defaultVariables ? defaultVariables : []
}

export const getDocumentValue = (newJob: JobT, documentName: string, defaultDocument: DocumentT): DocumentT => {
  return _.has(newJob, `documents.${documentName}`) && newJob.documents[documentName]
    ? newJob.documents[documentName]
    : defaultDocument
}
